<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          src="../../../assets/bckarrow.svg"
          class="pointer"
          alt=""
          @click="gotodashboard"
        />
        <div class="main-head ml-4">
          <span>Offer Accepted</span>
        </div>
      </div>
      <div class="viewopsheadjdcontainer mt-2">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="search-bar" style="width: 65%">
            <img
              class="searchicon"
              src="../../../assets/img/search-bar-icon.svg"
              alt=""
            />

            <b-form-input
              type="search"
              class="search-input"
              placeholder="Search candidate"
              v-model.trim="searchQuery"
              @keyup="textSearch()"
            ></b-form-input>
          </div>

          <b-button
            v-if="selectedCandidates.length > 0"
            class="hr-status"
            @click="openDocsMultiModel()"
          >
            Assign on-boarding docs
          </b-button>
        </div>
        <div class="tab-onboard mt-3">
          <b-tabs v-model="tabIndex">
            <b-tab
              title="Assign Documents"
              @click="
                getCandidates((status = '4'), (page = 1), (goToPage = null))
              "
            >
              <div>
                <!-- table starts -->
                <div class="table-main">
                  <table
                    class="
                      w-100
                      table-design
                      opshead-approve-head
                      jdtablecontent
                    "
                    :aria-describedby="'Assign Documents'"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 5%">
                          <span>
                            <b-form-checkbox
                              v-model="allCandidates"
                              @change="checkAllCandidates"
                            >
                            </b-form-checkbox>
                          </span>
                        </th>
                        <th class="candidate-row">
                          <span>Candidate Name</span>
                          <template v-if="statusValue == 'customerName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = 1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = -1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'customerName'),
                                (sortByValue = true),
                                (order = 1),
                                getCandidates()
                            "
                            src="../../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Date of joining</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Department</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Designation</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Candidate CTC</span>
                        </th>

                        <th class="candidate-row">
                          <span>Current status</span>
                        </th>
                        <th style="width: 15%" class="text-center">Actions</th>
                        <th style="width: 5%"></th>
                      </tr>
                    </thead>

                    <tbody v-if="sendDocsCandidates.length > 0">
                      <tr
                        v-for="(candidate, index) in sendDocsCandidates"
                        class="selected-table-cards"
                        :key="index"
                      >
                        <td class="text-center" style="width: 5%">
                          <span
                            class="color-bar"
                            style="background: #72738e"
                          ></span>
                          <span>
                            <b-form-checkbox
                              :value="candidate.RecCandidateID"
                              v-model="selectedCandidates"
                            >
                            </b-form-checkbox
                          ></span>
                        </td>

                        <td class="candidate-row">
                          {{
                            `${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{
                            candidate.dateOfJoining.slice(0, 10) | formatdate
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.department }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.designation }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.offeredCTC }}
                        </td>

                        <td class="candidate-row">Accepted By Candidate</td>

                        <td style="width: 15%" class="text-center">
                          <b-button
                            class="hr-status"
                            @click="
                              openDocsModel('single', candidate, index),
                                getDocuments()
                            "
                            :disabled="
                              selectedCandidates.includes(
                                candidate.RecCandidateID
                              )
                            "
                          >
                            Assign on-boarding docs
                          </b-button>
                        </td>

                        <td style="width: 5%" class="text-right">
                          <div class="d-flex align-items-center">
                            <div
                              class="p-2 mr-1"
                              @click="
                                goToCandidateDetails(candidate.RecCandidateID)
                              "
                            >
                              <img
                                v-b-popover.hover.top="'View'"
                                src="../../../assets/eyeicon.svg"
                                class="pointer"
                                alt=""
                              />
                            </div>
                            <div class="viewmore-parent">
                              <div class="pointer" :id="candidate.email">
                                <img
                                  src="../../../assets/img/hrportal/viewmore.svg"
                                  alt=""
                                />
                              </div>
                              <b-popover
                                :target="candidate.email"
                                triggers="hover"
                                placement="bottomleft"
                              >
                                <div
                                  @click="openNotInterested(candidate)"
                                  class="hr-nibox pointer"
                                >
                                  Not Interested
                                </div>
                              </b-popover>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="selected-table-cards">
                        <td class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- table ends -->
              </div>
            </b-tab>

            <b-tab
              title="Waiting"
              @click="
                getCandidates((status = '6'), (page = 1), (goToPage = null))
              "
            >
              <div>
                <!-- table starts -->
                <div class="table-main">
                  <table
                    class="
                      w-100
                      table-design
                      opshead-approve-head
                      jdtablecontent
                    "
                    :aria-describedby="'Waiting'"
                  >
                    <thead>
                      <tr>
                        <th style="width: 5%"></th>
                        <th class="candidate-row">
                          <span>Candidate Name</span>
                          <template v-if="statusValue == 'customerName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = 1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = -1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'customerName'),
                                (sortByValue = true),
                                (order = 1),
                                getCandidates()
                            "
                            src="../../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Date of joining</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Department</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Designation</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Candidate CTC</span>
                        </th>

                        <th class="candidate-row" style="width: 15%">
                          <span>Current status</span>
                        </th>

                        <th style="width: 15%" class="text-center">Actions</th>

                        <th style="width: 5%"></th>
                      </tr>
                    </thead>
                    <tbody v-if="waitingDocsCandidates.length > 0">
                      <tr
                        v-for="(candidate, index) in waitingDocsCandidates"
                        class="selected-table-cards"
                        :key="index"
                      >
                        <td class="text-center" style="width: 5%">
                          <span
                            class="color-bar"
                            style="background: #72738e"
                          ></span>
                        </td>

                        <td class="candidate-row">
                          {{
                            `${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{
                            candidate.dateOfJoining.slice(0, 10) | formatdate
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.department }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.designation }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.offeredCTC }}
                        </td>

                        <td
                          class="candidate-row text-truncate"
                          style="width: 15%"
                          v-b-tooltip.hover.bottom="candidate.statusDescription"
                        >
                          {{ candidate.statusDescription }}
                        </td>

                        <td style="width: 15%" class="text-center">
                          <b-button
                            class="addbtn pt-1 pb-1 pr-2 pl-2"
                            @click="getAssignedDocs(candidate)"
                          >
                            Resend Onboarding Docs
                          </b-button>
                        </td>

                        <td style="width: 5%" class="text-right">
                          <div class="d-flex align-items-center">
                            <div
                              class="p-2 mr-1"
                              @click="
                                goToCandidateDetails(candidate.RecCandidateID)
                              "
                            >
                              <img
                                v-b-popover.hover.top="'View'"
                                src="../../../assets/eyeicon.svg"
                                class="pointer"
                                alt=""
                              />
                            </div>
                            <div class="viewmore-parent">
                              <div class="pointer" :id="candidate.email">
                                <img
                                  src="../../../assets/img/hrportal/viewmore.svg"
                                  alt=""
                                />
                              </div>
                              <b-popover
                                :target="candidate.email"
                                triggers="hover"
                                placement="bottomleft"
                              >
                                <div
                                  @click="openNotInterested(candidate)"
                                  class="hr-nibox pointer"
                                >
                                  Not Interested
                                </div>
                              </b-popover>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="selected-table-cards">
                        <td class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- table ends -->
              </div>
            </b-tab>

            <b-tab
              title="Review Documents"
              @click="
                getCandidates((status = '7'), (page = 1), (goToPage = null))
              "
            >
              <div>
                <!-- table starts -->
                <div class="table-main">
                  <table
                    class="
                      w-100
                      table-design
                      opshead-approve-head
                      jdtablecontent
                    "
                    :aria-describedby="'Review Documents'"
                  >
                    <thead>
                      <tr>
                        <th style="width: 5%"></th>
                        <th class="candidate-row">
                          <span>Candidate Name</span>
                          <template v-if="statusValue == 'customerName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = 1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer ml-2"
                              @click="
                                (sortByValue = !sortByValue),
                                  (statusValue = 'customerName'),
                                  (order = -1);
                                getCandidates();
                              "
                              src="../../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer ml-2"
                            v-else
                            @click="
                              (filter = true),
                                (statusValue = 'customerName'),
                                (sortByValue = true),
                                (order = 1),
                                getCandidates()
                            "
                            src="../../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </th>
                        <th class="candidate-row" style="width: 10%">
                          <span>Date of joining</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Department</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Designation</span>
                        </th>

                        <th class="candidate-row" style="width: 10%">
                          <span>Candidate CTC</span>
                        </th>

                        <th class="candidate-row" style="width: 15%">
                          <span>Current status</span>
                        </th>

                        <th style="width: 15%" class="text-center">Actions</th>

                        <th style="width: 5%"></th>
                      </tr>
                    </thead>
                    <tbody v-if="reviewDocsCandidates.length > 0">
                      <tr
                        v-for="(candidate, index) in reviewDocsCandidates"
                        class="selected-table-cards"
                        :key="index"
                      >
                        <td class="text-center" style="width: 5%">
                          <span
                            class="color-bar"
                            style="background: #72738e"
                          ></span>
                        </td>

                        <td class="candidate-row">
                          {{
                            `${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{
                            candidate.dateOfJoining.slice(0, 10) | formatdate
                          }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.department }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.designation }}
                        </td>

                        <td class="candidate-row" style="width: 10%">
                          {{ candidate.offeredCTC }}
                        </td>

                        <td
                          class="candidate-row text-truncate"
                          v-b-tooltip.hover.bottom="candidate.statusDescription"
                        >
                          {{ candidate.statusDescription }}
                        </td>

                        <td style="width: 15%" class="text-center">
                          <b-button
                            class="hr-status"
                            @click="
                              goToReviewDocs(candidate.RecCandidateID),
                                getDocuments()
                            "
                          >
                            Review on-boarding docs
                          </b-button>
                        </td>

                        <td style="width: 5%" class="text-right">
                          <div class="d-flex align-items-center">
                            <div
                              class="p-2 mr-1"
                              @click="
                                goToCandidateDetails(candidate.RecCandidateID)
                              "
                            >
                              <img
                                v-b-popover.hover.top="'View'"
                                src="../../../assets/eyeicon.svg"
                                class="pointer"
                                alt=""
                              />
                            </div>
                            <div class="viewmore-parent">
                              <div class="pointer" :id="candidate.email">
                                <img
                                  src="../../../assets/img/hrportal/viewmore.svg"
                                  alt=""
                                />
                              </div>
                              <b-popover
                                :target="candidate.email"
                                triggers="hover"
                                placement="bottomleft"
                              >
                                <div
                                  @click="openNotInterested(candidate)"
                                  class="hr-nibox pointer"
                                >
                                  Not Interested
                                </div>
                              </b-popover>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="selected-table-cards">
                        <td class="text-center">No Records Found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- table ends -->
              </div>
            </b-tab>
          </b-tabs>

          <div
            class="paginaTion d-flex justify-content-between align-items-center"
          >
            <div class="d-flex">
              <span class="qb-gotopage-text p-1">Go to page</span>
              <b-form-input
                type="text"
                class="qb-pagination-num mr-1"
                v-model="goToPage"
                @keyup.enter="
                  goToPage === null || goToPage == '' || iscontainsNumber
                    ? ''
                    : gotopgnum(goToPage)
                "
              ></b-form-input>
              <b-button
                class="qb-pagination-addbtn"
                @click="gotopgnum(goToPage)"
                :disabled="
                  goToPage === null || goToPage == '' || iscontainsNumber
                "
              >
                <span
                  ><img src="../../../assets/whiterightarrow.svg" alt=""
                /></span>
              </b-button>
            </div>
            <div class="pagination">
              <b-pagination
                v-model="page"
                @input="getCandidates()"
                :total-rows="total"
                :per-page="count"
                align="center"
                first-number
                last-number
              >
                <template #prev-text
                  ><span
                    ><img src="../../../assets/leftvector.svg" alt="" /> </span
                ></template>
                <template #next-text
                  ><span
                    ><img src="../../../assets/rightarrow.svg" alt="" /></span
                ></template>
              </b-pagination>
            </div>
            <div class="qb-gotopage-text mr-2">
              Results : <span v-if="pageStart > total">0</span
              ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
              <span class="pl-1"></span> of <span class="pr-1"></span
              >{{ total }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="not-interested"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
      @hidden="closeNiModal"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Confirmation
      </div>
      <hr />
      <div @click="closeNiModal" class="xMarkCancel">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="modal-text">
          Do you want to move
          <span class="options-text"
            >&ldquo;{{ selectedCandidate.email }}&ldquo;</span
          >
          to uninterested?
        </div>
        <div class="topDiv mt-4">
          <label class="fieldsetStyle">Remarks</label>
          <b-form-textarea
            class="inputField"
            id="input-1"
            type="text"
            rows="3"
            max-rows="6"
            placeholder="Enter Remarks"
            v-model="niremarks"
          >
          </b-form-textarea>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div class="cancelbtntext pointer mr-4" @click="closeNiModal">
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="makeNotInterested"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      id="assign-docs"
      size="l"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      :no-close-on-backdrop="true"
      @hidden="closeAssignDocs"
    >
      <div
        class="page-heading d-flex justify-content-between align-items-center"
      >
        <div class="jd-modal-heading">
          <span>Assign Documents</span>
        </div>
      </div>
      <div @click="closeAssignDocs" class="xMarkCancel">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <hr />

      <div class="doc-modal mt-1 d-flex flex-column justify-content-between">
        <div class="doc-sub">
          <div class="w-100">
            <span class="doc-model-sub-head"> Select Experience Level </span>

            <b-form-radio-group
              class="
                mt-2
                options-text
                modal-radio-feedback
                d-flex
                justify-content-between
                align-items-center
              "
              v-model="isFresher"
            >
              <b-form-radio value="true">Fresher</b-form-radio>
              <b-form-radio value="false" class="mr-5">Experience</b-form-radio>
            </b-form-radio-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(0)"
            >
              <div class="heading-doc">Registration Form</div>
              <div>
                <img
                  v-if="!dropDownToggle[0]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="dropDownToggle[0]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in registrationForms"
                :key="index"
                :value="docs.value"
                v-model="selectedRegForm"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.name }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(1)"
            >
              <div class="heading-doc">Attach Documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[1]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="dropDownToggle[1]">
            <b-form-checkbox
              size="sm"
              v-for="(docs, index) in documentsList"
              :key="index"
              :value="docs"
              v-model="selectedDocs"
              class="qb-dropdown-option-sing options-text"
            >
              {{ docs.text }}
            </b-form-checkbox>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(2)"
            >
              <div class="heading-doc">Declaration Documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[2]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="dec-form-list" v-if="dropDownToggle[2]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in documentDetails"
                :key="index"
                :value="{
                  name: docs.documentName,
                  value: docs.documentID,
                }"
                v-model="selectedDecDocs"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.documentName }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="heading-doc mt-3">Select Expiry Date</div>
          <div class="topDiv datepicker-cust mt-3">
            <label class="datefieldsetStyle"
              >Expiry Date&nbsp;<span class="asterik">*</span></label
            >
            <b-form-datepicker
              ref="dob"
              class="pointer joiningstyle"
              v-model="$v.expiryDate.$model"
              :class="{ error: $v.expiryDate.$error }"
            ></b-form-datepicker>
            <div
              class="validationicon-exp"
              v-if="$v.expiryDate.$dirty && !$v.expiryDate.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../../assets/deletepopupicon.svg" alt="" />
            </div>
            <img
              @click="gotoexpdate"
              class="calender-class pointer"
              src="../../../assets/calenderIcon.svg"
              alt=""
            />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            class="addbtn confirm-btn"
            @click="reassign == true ? putDocs() : postDocs()"
          >
            Confirm & Send
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getOfferInitializePagination,
  sendDocsToCandidate,
  ReSendDocsToCandidate,
  setNotInterested,
  getRequiredDocuments,
} from "../../../utils/apiFunctions";
import { required } from "vuelidate/lib/validators";
import Spinner from "../../../components/fixedcomponents/Spinner.vue";
import toast from "../../../components/mixin/toast";

export default {
  name: "OnboardingCandidates",
  components: {
    Spinner,
  },
  data() {
    return {
      // NUMBER
      totalPages: null,
      tabIndex: 0,
      count: 50,
      page: 1,
      position: null,
      selectedID: null,
      selectionType: null,
      goToPage: null,
      total: null,
      pageStart: null,
      pageEnd: null,
      timer: null,

      //STRINGS
      expiryDate: "",
      actionList: "",
      searchQuery: "",
      isFresher: "true",
      niremarks: "",
      sortBy: "updatedAt",
      status: "4",
      order: "-1",
      statusValue: "",
      selectedCandidateID: "",

      // BOOLEAN
      allCandidates: false,
      LoaderStatus: false,
      filter: false,
      sortByValue: false,
      reassign: false,

      //OBJECTS
      selectedCandidate: {},

      //ARRAY OF OBJECTS
      documentDetails: [],
      experienced: [
        { text: "Fresher", value: true },
        { text: "Experience", value: false },
      ],
      registrationForms: [
        { name: "Employee Details", value: "employeeDetails" },
        { name: "Educational Details", value: "educationalDetails" },
        { name: "Family Details", value: "familyDetails" },
        { name: "Nominee Details", value: "nomineeDetails" },
        { name: "Work Details", value: "workDetails" },
      ],
      documentsList: [],
      declarationDocs: [
        { name: "Self Declaration Form", value: "selfDeclarationForm" },
        { name: "Employee PF Form", value: "employeePfForm" },
      ],

      //ARRAYS
      dropDownToggle: [false, false, false],
      selectedCandidates: [],
      sendDocsCandidates: [],
      reviewDocsCandidates: [],
      waitingDocsCandidates: [],
      selectedRegForm: [],
      selectedDocs: [],
      selectedDecDocs: [],
    };
  },
  validations() {
    return {
      expiryDate: {
        required,
      },
    };
  },
  mixins: [toast],
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },
  computed: {
    iscontainsNumber() {
      return !/^[1-9]\d*$/.test(this.goToPage);
    },
  },
  created() {
    this.getCandidates();
    this.getRequiredDocuments();
  },
  watch: {
    // SELECT ALL CANDIDATES BASED ON SELECTED CANDIDATES
    selectedCandidates() {
      if (this.selectedCandidates.length == this.sendDocsCandidates.length) {
        this.allCandidates = true;
      } else {
        this.allCandidates = false;
      }
    },
    isFresher() {
      if (this.isFresher == "false") {
        this.selectedRegForm = [
          "employeeDetails",
          "educationalDetails",
          "familyDetails",
          "workDetails",
        ];
      } else {
        this.selectedRegForm = [
          "employeeDetails",
          "educationalDetails",
          "familyDetails",
        ];
      }
    },
  },
  methods: {
    async getRequiredDocuments() {
      const res = await getRequiredDocuments();
      if (res.status == 200) {
        this.documentsList = res.data.data;
        const requiredDocs = ["Aadhar Card", "Pan Card"];

        this.selectedDocs = this.documentsList.filter((doc) =>
          requiredDocs.includes(doc.text)
        );
      }
    },

    // search function
    textSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.getCandidates();
      }, 400);
    },

    // Go to selected Page
    gotopgnum(index) {
      if (index > 0) {
        this.page = Math.min(Math.max(1, index), this.totalPages);
        this.getCandidates();
      }
      this.goToPage = null;
    },
    // ASYNCHRONOUS FUNCTIONS ----- START
    // MAKE CANDIDATE AS NOT INTERESTED
    async makeNotInterested() {
      try {
        let payload = {
          candidateID: this.selectedCandidate.RecCandidateID,
          remarks: this.niremarks,
        };
        const response = await setNotInterested(payload);
        if (response.status == 200) {
          this.getCandidates();
          this.closeNiModal();
          this.selectedCandidate = {};
          this.successModal("Candidate moved to not interested");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Failed! makeNotInterested ! status: ${error.status}`);
      }
    },
    // GET CANDIDATES FOR ASSIGNING AND REVIEWING DOCUMENTS
    async getCandidates() {
      this.LoaderStatus = true;
      try {
        let payload = {
          sortBy: this.sortBy,
          order: this.order,
          count: this.count,
          status: this.status,
          actionList: this.actionList,
          searchQuery: this.searchQuery,
          page: this.page - 1,
        };
        const response = await getOfferInitializePagination(payload);
        if (response.status == 200) {
          if (this.status == "4") {
            this.sendDocsCandidates = response.data.data.data;
            this.total = response.data.data.total;
            this.pageStart = response.data.data.pageStart;
            this.pageEnd = response.data.data.pageEnd;
            this.totalPages = Math.ceil(
              parseInt(this.total) / parseInt(this.count)
            );
          } else if (this.status == "7") {
            this.reviewDocsCandidates = response.data.data.data;
            this.total = response.data.data.total;
            this.pageStart = response.data.data.pageStart;
            this.pageEnd = response.data.data.pageEnd;
            this.totalPages = Math.ceil(
              parseInt(this.total) / parseInt(this.count)
            );
          } else {
            this.waitingDocsCandidates = response.data.data.data;
            this.total = response.data.data.total;
            this.pageStart = response.data.data.pageStart;
            this.pageEnd = response.data.data.pageEnd;
            this.totalPages = Math.ceil(
              parseInt(this.total) / parseInt(this.count)
            );
          }
        }
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! getCandidates ! status: ${error.status}`);
      }
    },

    // REASSIGN DOCS TO CANDIDATE
    async putDocs() {
      if (
        this.selectedRegForm.length === 0 &&
        this.selectedDocs.length === 0 &&
        this.selectedDecDocs.length === 0
      ) {
        this.errorModal("At least one document must be selected");
        return;
      }

      this.$v.expiryDate.$touch();
      if (this.$v.expiryDate.$invalid) return;

      this.loaderStatus = true;
      try {
        const payload = {
          expiryDate: this.expiryDate,
          candidateID: this.selectedCandidateID,
          document: {
            documents: this.selectedDocs,
            decForm: this.selectedDecDocs,
          },
        };

        this.registrationForms.forEach((form) => {
          payload.document[form.value] = this.selectedRegForm.includes(
            form.value
          );
        });

        const response = await ReSendDocsToCandidate(payload);
        if (response.status === 200) {
          await this.getCandidates();
          this.closeAssignDocs();
          this.successModal("Reassigned documents successfully");
        } else {
          this.errorModal(response.data.data.status);
        }
        this.loaderStatus = false;
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // ASSIGN DOCS TO CANDIDATE
    async postDocs() {
      if (
        this.selectedRegForm.length == 0 &&
        this.selectedDocs.length == 0 &&
        this.selectedDecDocs.length == 0
      ) {
        this.errorModal("Alteast one document must be selected");
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.loaderStatus = true;
          try {
            let payload = {
              expiryDate: this.expiryDate,
              candidateIDs: [this.selectedID],
              document: {
                documents: this.selectedDocs,
                decForm: this.selectedDecDocs,
              },
            };
            this.registrationForms.forEach((form) => {
              payload.document[form.value] = this.selectedRegForm.includes(
                form.value
              );
            });
            const response = await sendDocsToCandidate(payload);
            if (response.status == 200) {
              await this.getCandidates();
              this.closeAssignDocs();
              this.successModal("Documents sent successfully");
            } else {
              this.errorModal(response.data.data.status);
            }
            this.loaderStatus = false;
          } catch (error) {
            this.loaderStatus = false;
            throw new Error(`Failed! postDocs ! status: ${error.status}`);
          }
        }
      }
    },
    toCamelCase(str) {
      let arr = str.match(/[a-z]+|\d+/gi);
      return arr.map((m, i) => {
        let low = m.toLowerCase();
        if (i != 0) {
          low = low.split("").map((s, k) => (k == 0 ? s.toUpperCase() : s))
            .join``;
        }
        return low;
      }).join``;
    },

    // ASYNCHRONOUS FUNCTIONS ----- END
    // CHECK WHETHER ALL CANDIDATES ARE SELECTED
    checkAllCandidates() {
      if (this.allCandidates) {
        const candidatesToAdd = this.sendDocsCandidates
          .map((candidate) => candidate.RecCandidateID)
          .filter(
            (candidateID) => !this.selectedCandidates.includes(candidateID)
          );

        this.selectedCandidates.push(...candidatesToAdd);
      } else {
        this.selectedCandidates = [];
      }
    },

    gotoexpdate() {
      this.$refs.dob.$el.children[0].click();
    },

    // HELPER FUNCTIONS --END

    // HELPER FUNCTIONS FOR B-MODALS ---- START
    // OPEN NOT INTERESTED MODDL
    openNotInterested(candidate) {
      this.selectedCandidate = candidate;
      this.$bvModal.show("not-interested");
    },

    // CLOSE NOT INTERESTED MODEL
    closeNiModal() {
      this.niremarks = "";
      this.$bvModal.hide("not-interested");
    },
    openDocsMultiModel() {
      this.$bvModal.show("assign-docs");
    },
    // OPEN ASSIGN DOCS MODAL
    openDocsModel(type, data, index) {
      if (type == "single") {
        this.position = index;
        this.selectedID = data.RecCandidateID;
      }
      if (data.experience != 0) {
        this.isFresher = "false";
      } else {
        this.isFresher = "true";
      }
      this.selectionType = type;
      this.selectedRegForm = [
        "employeeDetails",
        "educationalDetails",
        "familyDetails",
      ];
      this.$bvModal.show("assign-docs");
    },

    //CLOSE ASSIGN DOCS MODAL
    closeAssignDocs() {
      this.selectedDocs = [];
      this.selectedRegForm = [];
      this.selectedDecDocs = [];
      this.dropDownToggle = [false, false, false];
      this.reassign = false;
      this.isFresher = null;
      this.position = null;
      this.expiryDate = "";
      this.$v.$reset();
      this.$bvModal.hide("assign-docs");
    },
    // HELPER FUNCTIONS FOR B-MODALS ---- END

    // HELPER FUNCTIONS FOR TOGGLING DOCS LIST ---- START

    toggleDropDown(index) {
      this.dropDownToggle[index] = !this.dropDownToggle[index];
      let current = this.dropDownToggle[index];
      for (let i in this.dropDownToggle) {
        if (i != index) {
          if (current) {
            this.dropDownToggle[i] = false;
          }
        }
      }
      this.$forceUpdate();
    },

    // HELPER FUNCTIONS FOR TOGGLING DOCS LIST ---- START

    // HELPER FUNCTIONS FOR NAVIGATIONS ---START
    goToCandidateDetails(data) {
      this.$router.push({
        name: "CandidateDetails",
        params: {
          candidateID: data,
        },
        query: {
          redirect: this.$route.name,
        },
      });
    },
    gotodashboard() {
      this.$router.push({
        name: "Dashboard",
      });
    },

    goToReviewDocs(candidateID) {
      this.$router.push({
        name: "ViewOnboardingCandidate",
        params: {
          candidateID: candidateID,
        },
        query: {
          redirect: "OnboardingCandidates",
        },
      });
    },
    // HELPER FUNCTIONS FOR NAVIGATIONS ---END
  },
};
</script>
<style>
.hr-nibox {
  padding: 10px;
  background-color: #f4f4f4;
  border-radius: 5px;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #545454;
}
.hr-status {
  border-radius: 5px;
  font-weight: 400;
  text-align: center;
  font-size: 13px;
  color: #fafafa;
  padding: 5px;
}
.enable {
  background: #72738e;
  cursor: pointer;
}
.disable {
  background: #c4c4c4;
}
.options-text {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}
.datepicker-cust .btn {
  padding: 0.375rem 0;
}
.calender-class {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 1;
}
.doc-modal {
  min-height: auto;
  max-height: calc(100vh - 250px);
  overflow: auto;
}

.qb-dropdown-option-box:nth-child(even) {
  background: #fdfdfd;
  padding: 10px 30px;
}
.qb-dropdown-option-box:nth-child(odd) {
  background: #f4f4f4;
  padding: 10px 30px;
}
.confirm-btn {
  height: 34px;
  width: 140px;
}
.doc-sub {
  height: 700px;
  overflow: auto;
  padding-left: 5px;
  padding-right: 5px;
}
.heading-doc {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}
.reg-form-list {
  height: 220px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  overflow: auto;
  transition: visibility 0s, opacity 0.5s;
}
.dec-form-list {
  max-height: 160px;
  overflow: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.reg-form {
  height: 47px;
  width: 100%;
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}
.doc-model-sub-head {
  font-weight: 700;
  font-size: 14px;
  color: #545454;
}
.form-headings {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}
.nav-tabs {
  border-bottom: none;
}
.selected-table-cards:hover {
  background: #e7e8f5;
}
.tp-reports-table tbody tr {
  height: 50px;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  background: #fcfcfc;
  box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
  margin: 8px 0px 8px 0px;
  width: 99.5%;
  display: table;
  border-radius: 3px;
  table-layout: fixed;
}
.candidate-row {
  width: 15%;
  text-align: left;
}
.tab-onboard {
  min-width: 400px;
  margin: 0 auto;
  margin-bottom: 68px;
  overflow: hidden;
  transition: border 250ms ease;
}
.topDiv > .joiningstyle {
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgb(0 0 0 / 10%);
}
.b-form-btn-label-control.form-control > .btn > svg {
  display: none !important;
}

.tab-onboard ul li a:before {
  right: -20px;
  margin-top: -1px;
  transform: skew(30deg, 0deg);
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 0px, inset rgb(255 255 255 / 9%) -1px 0;
  border-right: 1px solid #e7e7e7;
  border-top: 1px solid #e7e7e7;
  display: block;
  content: " ";
  position: absolute;
  top: -2px;
  height: 110%;
  width: 44px;
  transition: all 250ms ease;
  background: #ececec;
}
.tab-onboard li {
  width: 231px;
}
.tab-onboard .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background: #72738e;
  border: 1px solid #72738e;
  font-weight: 600;
  font-size: 14px;
  margin-top: -1px;
  color: #ffffff;
  text-align: center;
}

.tab-onboard a {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
  text-align: center;
}

.tab-onboard ul li a.active:before {
  background: #72738e;
}
.tab-onboard ul li a {
  display: block;
  float: right;
  margin-right: 30px;
  width: 200px;
  z-index: 2;
  position: relative;
  cursor: pointer;
  text-transform: uppercase;
  font: 600 13px/20px roboto, "Open Sans", Helvetica, sans-serif;
  transition: all 250ms ease;
  border: 1px solid #e7e7e7;
  background: #ececec;
  border-bottom: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}
</style>

<style scoped>
.topDiv > .inputField {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px !important;
  z-index: 0 !important;
  padding-left: 6px;
}
.validationicon-date {
  position: absolute;
  top: 5px;
  right: 34px !important;
  background: var(--bg-white);
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(13px);
  background: white;
}
input:checked + .slider {
  background-color: #72738e;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: #adb5bd;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #72738e;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}
</style>
<style scoped>
.custom-control {
  z-index: unset !important;
}
</style>

<style>
.viewopsheadjdcontainer {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  height: calc(100vh - 150px);
  padding: 15px;
}
</style>
